var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import ReactDOM from 'react-dom';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
var cls = classNames('menu-portal');
export var MenuPortalDefaultProps = {
  style: {}
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: ", ";\n  "], ["\n    font-family: ", ";\n  "])), theme.FONT('sans'))
});
// -------- Components -------->
var My = {
  NAME: 'MenuPortal',
  Container: styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var MenuPortal = React.forwardRef(function (props, ref) {
  var _a = useComponentProps(My.NAME, MenuPortalDefaultProps, props),
    className = _a.className,
    children = _a.children;
  var style = __assign({
    position: 'absolute',
    zIndex: 1000
  }, props.style);
  return ReactDOM.createPortal(React.createElement(My.Container, {
    ref: ref,
    style: style,
    className: cls.name(className)
  }, children), document.body);
});
/* @ts-ignore */
MenuPortal.cls = cls;
var templateObject_1, templateObject_2;